<template>
  <v-row class="pa-5" v-if="benefits">
    <v-col cols="12">
      <h2>Benefits Table</h2>
    </v-col>
    <v-col cols="12">
      <results-unit-table-inline
        :benefits="benefits"
        :attributes="attributes"
        :lang="lang"
      />
    </v-col>
  </v-row>
</template>

<script>
// import lodash from "lodash";
const fb = require("@/firebaseConfig.js");
import { mapState } from "vuex";
import ResultsUnitTableInline from "./ResultsUnitTableInline";

export default {
  name: "ResultsBenefitsTableAggregated",
  data() {
    return {
      doc: null,
      attributes: [],
      benefits: [],
      dialog: false,
    };
  },
  props: {
    uid: String,
    id: String,
    model: String,
    lang: String,
  },
  components: { ResultsUnitTableInline },
  mounted() {
    this.getAttributes();
  },
  computed: {
    ...mapState([
      "userProfile",
      "currentUser",
      "currentProject",
      "currentProjectModel",
    ]),
  },
  methods: {
    getAttributes() {
      console.log("get attributes");
      let ref = fb.attributesPt1ExCollection.where("pid", "==", this.id);
      ref.onSnapshot((querySnapshot) => {
        let items = [];
        querySnapshot.forEach((docs) => {
          let post = docs.data();
          post.doc.attributes.forEach((benefit) => {
            items.push(benefit);
          });
        });
        this.attributes = items;
        this.getExercise();
      });
    },
    getExercise() {
      console.log("get exercise");
      let ref = fb.attributesPt2ExCollection.where("pid", "==", this.id);
      ref.onSnapshot((querySnapshot) => {
        let items = [];
        querySnapshot.forEach((docs) => {
          let post = docs.data();
          post.doc.benefits.forEach((benefit) => {
            items.push(benefit);
          });
          // this.getResults(post.doc);
        });
        this.benefits = items;
      });
    },
  },
};
</script>
